import React, { useState, useEffect } from 'react';
import { Button, Table, Container, Alert, Modal, Form, Row, Col } from 'react-bootstrap';
import Loader from '../../../components/loading';
import { useSelector, useDispatch } from 'react-redux';
import { fetchVendas, updateStatusVenda, emailConfirmacaoVendaStatus, setSearchTerm, setSortDirection, setCurrentPage } from '../../../redux/reducers/vendasSlice';
import PaginationComponent from '../../../components/paginacao';
import { formatPriceBR } from '../../../util';
const Vendas = () => {

    const [selectedVenda, setSelectedVenda] = useState(null);
    const [message, setMessage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showAlert, setAlert] = useState(false);
    const [showModalStatus, setShowModalStatus] = useState(false);
    const [status, setStatus] = useState('1');
    const dispatch = useDispatch();
    const { vendas, loading, searchTerm, sortDirection, error, currentPage, totalItems } = useSelector((state) => state.vendas);
    //const [currentPage, setCurrentPage] = useState(1);
    const BASE_URL = process.env.REACT_APP_BASE_URL
    //Paginacao
    //console.log(useSelector((state) => state.vendas),'state_vendas')
    const itemsPerPage = 10
    const totalPages = Math.ceil(totalItems / itemsPerPage);


    const STATUS_MAP = {
        1: "Pendente",
        2: "Aprovado",
        3: "Cancelado",
        4: "Retirada",
        5: "Entregue",
    };
    const getStatusLabel = (value) => STATUS_MAP[value] || "Desconhecido";

    const handlePageChange = (newPage) => {
        dispatch(setCurrentPage(newPage));
    };

    useEffect(() => {
        dispatch(fetchVendas({ page: currentPage, searchTerm, sortDirection }));
    }, [dispatch, currentPage, searchTerm, sortDirection]);

    useEffect(() => {
        setAlert(true)
    }, [message]);

    // Função para visualizar detalhes do pedido
    const handleViewDetails = (venda) => {
        console.log(venda, 'venda')
        setSelectedVenda(venda);
        setShowModal(true);
    };

    // Função para abrir o modal de alteração de status
    const handleStatusChange = (venda) => {
        setSelectedVenda(venda);
        setShowModalStatus(true)
    };

    const handleStatusSave = async () => {
        try {
            const resultAction = await dispatch(updateStatusVenda({ id: selectedVenda.id, status }));
            if (updateStatusVenda.fulfilled.match(resultAction)) {
                // Após atualização de status, dispara o e-mail específico para o status
                setAlert(false)
                setMessage('Status atualizado com sucesso!');
                await dispatch(emailConfirmacaoVendaStatus({ order_code: selectedVenda.order_code, status }));
            }
        } catch (error) {
            console.error('Erro ao atualizar status ou enviar e-mail:', error);
        } finally {
            setShowModalStatus(false); // Fecha o modal
        }
    };

    // Buscar por código ou nome
    const handleSearch = (e) => {
        dispatch(setSearchTerm(e.target.value));
    };

    const handleSort = () => {
        const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        dispatch(setSortDirection(newDirection));
    }



    return (
        <Container>
            <h2 className='text-center titulo-pagina'><i style={{ color: '#ff7a00' }} className="fa-solid fa-cart-shopping"></i> Pedido de  Vendas</h2>
            {message && (
                <Alert className="text-center" variant="success" show={showAlert}>
                    {message}
                    <Button className="m-3" variant="close" onClick={() => setAlert(false)}></Button>
                </Alert>
            )}
            {error && (
                <Alert className="text-center" variant="danger">
                    <div>{JSON.stringify(error)}</div>
                    <Button className="m-3" variant="close" ></Button>
                </Alert>
            )}
            {/* Campo de busca */}
            <div className="mb-3 mt-3 d-flex justify-content-end align-items-center">
                <div className="position-relative" style={{ maxWidth: '300px' }}>
                    <Form.Control
                        type="text"
                        placeholder="Buscar por ID ou nome..."
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{ paddingRight: '2rem', backgroundColor: '#fff' }} // Cor de fundo do campo
                    />
                    {/* Exibe o ícone somente se existir texto */}

                    <i
                        className="fa-solid fa-xmark"
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '10px',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#888', // Ajuste a cor se quiser
                        }}
                        onClick={() => handleSearch({ target: { value: '' } })}
                    />

                </div>
                <Button variant="secondary" onClick={handleSort} className="p-1 ms-2">
                    Ordenar
                    {sortDirection === 'asc' ? (
                        <i className="fa-solid fa-sort-up p-2"></i>
                    ) : (
                        <i className="fa-solid fa-sort-down p-2"></i>
                    )}
                </Button>
            </div>
            <div className='d-flex justify-content-center'>
                <PaginationComponent
                    currentPage={currentPage}
                    lastPage={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <Loader loading={loading} />
                <Table bordered hover responsive className='tabela-painel text-center mt-4' style={{ fontSize: '0.7em' }}>
                    <thead>
                        <tr className='cabecalho-tabela'>
                            <th>N° pedido</th>
                            <th>Cliente</th>
                            <th>Data do Pedido</th>
                            <th>Status</th>
                            <th>Forma Pag.</th>
                            <th>Total</th>
                            <th >Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vendas?.map((venda, index) => (
                            <tr key={venda.id} className='celula-tabela'>
                                <td>{venda.id}</td>
                                <td>{venda.user?.name || 'Cliente não identificado'}</td>
                                <td>{new Date(venda.created_at).toLocaleDateString()}</td>
                                <td>{getStatusLabel(venda.payment?.status)}</td>
                                <td >{venda.payment?.payment_method || 'N/A'}</td>
                                <td>{formatPriceBR(!isNaN(Number(venda.total_price)) ? Number(venda.total_price).toFixed(2) : 'Valor inválido')}</td>
                                <td>
                                    <div class="table-actions">
                                        <Button
                                            variant="info"
                                            size="sm"
                                            className="me-2 botao-acao"
                                            onClick={() => handleViewDetails(venda)}
                                        >
                                            Visualizar
                                        </Button>
                                        <Button
                                            variant="warning"
                                            size="sm"
                                            className='botao-acao'
                                            onClick={() => handleStatusChange(venda)}
                                        >
                                            Alterar Status
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Modal para visualizar detalhes */}
            <Modal className="modal-custom" show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal' >Detalhes do Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedVenda && (
                        <div>
                            <div className='shadow-lg bg-white rounded' style={{ borderLeft: '5px solid rgb(243, 165, 44)', borderRadius: '10px', padding: '20px', marginTop: '20px', width: '100%' }}>
                                <h5 className='text-center'>Cliente</h5>
                                <p><strong>Nome:</strong> {selectedVenda.user?.name}</p>
                                <p><strong>CPF:</strong> {selectedVenda.user?.cpf}</p>
                                <p><strong>Email:</strong> {selectedVenda.user?.email}</p>
                                <p><strong>Telefone:</strong> {selectedVenda.user?.telefone}</p>
                                <p><strong>Data de Nascimento:</strong> {selectedVenda.user?.data_nascimento}</p>
                            </div>
                            <div className='shadow-lg bg-white rounded' style={{ borderLeft: '5px solid rgb(243, 165, 44)', borderRadius: '10px', padding: '20px', marginTop: '20px', width: '100%' }}>
                                <h5 className='text-center'> Endereço</h5>
                                <p><strong>Rua:</strong> {selectedVenda.user?.address?.address}</p>
                                <p><strong>N°:</strong> {selectedVenda.user?.address?.number}</p>
                                <p><strong>Complemento:</strong> {selectedVenda.user?.address?.complement}</p>
                                <p><strong>Bairro:</strong> {selectedVenda.user?.address?.neighborhood}</p>
                                <p><strong>Cidade:</strong> {selectedVenda.user?.address?.city}</p>
                                <p><strong>Estado:</strong> {selectedVenda.user?.address?.state}</p>
                                <p><strong>CEP:</strong> {selectedVenda.user?.address?.cep}</p>
                            </div>
                            <div className='shadow-lg bg-white rounded' style={{ borderLeft: '5px solid rgb(243, 165, 44)', borderRadius: '10px', padding: '20px', marginTop: '20px', width: '100%' }}>
                                <h5 className='text-center'>Pedido:</h5>
                                <p><strong>Status: </strong>{getStatusLabel(selectedVenda.payment?.status)} </p>
                                <p><strong>Forma de Pagamento:</strong> {selectedVenda.payment?.payment_method}</p>
                                <p><strong>Total:</strong>  {!isNaN(Number(selectedVenda.total_price)) ? formatPriceBR(Number(selectedVenda.total_price).toFixed(2)) : 'valor inválido'}</p>
                                {selectedVenda?.order_items?.map((item) => (
                                    <Row>
                                        <Col lg={6} md={6} xs={12} className='d-flex justify-content-center align-items-center pb-3'>
                                            <img
                                                variant="top"
                                                src={
                                                    item?.product?.images[0]?.url
                                                        ? item?.product?.images[0]?.url.startsWith("data:image") // Verifica se é base64
                                                            ? item?.product?.images[0]?.url // Base64
                                                            : `${BASE_URL}storage/${item?.product?.images[0]?.url}` // Caminho no servidor
                                                        : "default-image-path" // Caminho para uma imagem padrão
                                                }
                                                alt="Produto"
                                                style={{ maxWidth: '120px', objectFit: 'contain' }}
                                            />
                                        </Col>
                                        <Col lg={6} md={6} xs={12} className='text-center'>
                                            <p>{item.product.name}</p>
                                            <p>{item.quantity} x  {formatPriceBR(Number(item.unit_price).toFixed(2))} =  {formatPriceBR(Number(item.total_price).toFixed(2))}</p>
                                        </Col>
                                    </Row>
                                ))}
                            </div>

                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {/* Modal para alterar status */}
            <Modal show={showModalStatus} onHide={() => setShowModalStatus(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Alterar Status do Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="status">
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                            as="select"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="1">Pendente</option>
                            <option value="2">Aprovado</option>
                            <option value="3">Cancelado</option>
                            <option value="4">Retirada</option>
                            <option value="5">Entregue</option>
                        </Form.Control>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalStatus(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleStatusSave}>
                        {loading ? 'Atualizando...' : 'Atualizar Status'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default Vendas;
